import logrocket from 'logrocket'
import { isPreviewMode } from '@/assetSource'
import { type User, useAuthStore } from '@/stores/auth'

const LOGROCKET_APP_ID = import.meta.env.VITE_LOGROCKET_APP_ID

let hasInitialized = false

const isDevelopment = process.env.NODE_ENV === 'development'

export class LogRocketService {
  private unsubscribe?: () => void

  init() {
    if (hasInitialized || isDevelopment || isPreviewMode()) return

    if (!LOGROCKET_APP_ID) {
      console.error('LogRocket: VITE_LOGROCKET_APP_ID not configured')
      return
    }

    logrocket.init(LOGROCKET_APP_ID)

    hasInitialized = true

    this.setupUserSubscription()
  }

  identify(user: User) {
    if (isDevelopment || isPreviewMode()) return

    const traits = Object.entries(user).reduce<
      Record<string, string | number | boolean>
    >((result, [key, value]) => {
      if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        result[key] = value
      }

      return result
    }, {})

    logrocket.identify(user.id, {
      ...traits,
      name: user.fullName,
    })
  }

  /**
   * Setup user subscription to identify user when they are logged in
   */
  private setupUserSubscription() {
    const { user } = useAuthStore.getState()

    if (user) {
      this.identify(user)
    }

    // Subscribe to future changes
    this.unsubscribe = useAuthStore.subscribe(({ user }) => {
      if (!user) return

      this.identify(user)
    })
  }

  destroy() {
    this.unsubscribe?.()
  }
}
